import { render, staticRenderFns } from "./TgNotificationPopup.vue?vue&type=template&id=6582f157&"
import script from "./TgNotificationPopup.vue?vue&type=script&lang=js&"
export * from "./TgNotificationPopup.vue?vue&type=script&lang=js&"
import style0 from "./TgNotificationPopup.vue?vue&type=style&index=0&id=6582f157&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports